import react, { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import selectIcon from "./utils/selectIcon";

import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";

const useStyles = makeStyles((theme) => ({
  ellipsis: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },  
}));

const Game = (props) => {
  const { game, search, color } = props;
  
  const classes = useStyles();

  const searching = search && search.length > 0;

  const primary = game.home.length > 0 ? game.home : game.name;

  const secondary = game.away.length > 0 ?
        game.away :
        `${game.venueCity}, ${game.venueState}`;

  const primaryParts = searching ? parse(primary, match(primary, search)) : [];
  const secondaryParts = searching ? parse(secondary, match(secondary, search)) : [];

  let awayLine = "";
  let homeLine = "";
  let lineWidth = 0;
  if (game.spread && game.spread.length > 0 && (game.sport === "Football" || game.sport === "Basketball")) {
    lineWidth = 2;
    awayLine = game.spreadValue < 0 ? `+${-game.spreadValue}` : `${-game.spreadValue}`;
    homeLine = game.spreadValue > 0 ? `+${game.spreadValue}` : `${game.spreadValue}`;
  }
  else if (game.homeLine && game.homeLine.length > 0 && game.awayLine && game.awayLine.length > 0) {
    lineWidth = 2;
    awayLine = game.awayLine;
    homeLine = game.homeLine;
  }
  const drawWidth = game.drawLine && game.drawLine.length > 0 ? 2 : 0;
  const totalWidth = game.total && game.total.length > 0 ? 2 : 0;
  const outcomeWidth = game.outcomePlayer && game.outcomePlayer.length > 0 ? 6 : 0;
  const titleWidth = 12 - lineWidth - drawWidth - totalWidth - outcomeWidth;

  let meta = "";
  if (game.week && game.week > 0) {
    meta = `Week ${game.week}`;
  }
  else if (game.laps && game.laps > 0) {
    meta = `${game.laps} laps / ${game.distance} miles`;
  }
  else if (game.purse && game.purse > 0) {
    meta = game.money;
  }

  const hasStartTime = game.sport !== "Golf";
  const secondaryColor = color || "textSecondary";

  return (
    <Grid container>
      <Grid item xs={hasStartTime ? 6 : 10}>
        <Typography variant="body2" color={secondaryColor}>{
          game.endDate.length > 0 ?
            `${game.startDate} - ${game.endDate}` :
            game.startDate                              
        }</Typography>
      </Grid>
      <Grid item xs={hasStartTime ? 6 : 2}>
        <Typography variant="body2" color={secondaryColor} align="right" className={classes.ellipsis}>
          {hasStartTime ? game.startTime : null}
          {game.network.length > 0 ? ` on ${game.network}` : null}
        </Typography>
      </Grid>
      <Grid item xs={titleWidth}>
        <Typography className={classes.ellipsis}>
          {(primaryParts.length > 0) ?
           primaryParts.map((part, index) => (
             <span
               key={index}
               style={{
                 fontWeight: part.highlight
                   ? 700
                   : 400,
               }}
             >
               {part.text}
             </span>
           )) : primary }
        </Typography>
      </Grid>
      { lineWidth > 0 && (
        <Grid item xs={lineWidth}>
          <Typography variant="subtitle2" color={secondaryColor} align="right">
            { homeLine }
          </Typography>
        </Grid>)}
      { drawWidth > 0 && (
        <Grid item xs={drawWidth}>
          <Typography variant="subtitle2" color={secondaryColor} align="right">
            Draw
          </Typography>
        </Grid>)}
      { totalWidth > 0 && (
        <Grid item xs={totalWidth}>
          <Typography variant="subtitle2"  color={secondaryColor} align="right">
            Total
          </Typography>
        </Grid>)}
      { outcomeWidth > 0 && (
        <Grid item xs={outcomeWidth}>
          <Typography variant="subtitle2"  color={secondaryColor} align="right" className={classes.ellipsis}>
            {game.outcomePlayer}
          </Typography>
        </Grid>)}
      <Grid item xs={titleWidth}>
        <Typography className={classes.ellipsis}>
          {(secondaryParts.length > 0) ?
           secondaryParts.map((part, index) => (
             <span
               key={index}
               style={{
                 fontWeight: part.highlight
                   ? 700
                   : 400,
               }}
             >
               {part.text}
             </span>
           )) : secondary }
        </Typography>
      </Grid>
      { lineWidth > 0 && (
        <Grid item xs={lineWidth}>
          <Typography variant="subtitle2" color={secondaryColor} align="right">
            { awayLine }
          </Typography>
        </Grid>)}
      { drawWidth > 0 && (
        <Grid item xs={drawWidth}>
          <Typography variant="subtitle2" color={secondaryColor} align="right">
            { game.drawLine }
          </Typography>
        </Grid>)}
      { totalWidth > 0 && (
        <Grid item xs={totalWidth}>
          <Typography variant="subtitle2" color={secondaryColor} align="right">
            { game.total }
          </Typography>
        </Grid>)}
      { outcomeWidth > 0 && (
        <Grid item xs={outcomeWidth}>
          <Typography variant="subtitle2" color={secondaryColor} align="right">
            { game.outcomeOdds }
          </Typography>
        </Grid>)}
      <Grid item xs={meta.length > 0 ? 8 : 11} className={classes.ellipsis}>
        <Typography variant="overline" color={secondaryColor}>
          { game.venue.length > 0 ? `@ ${game.venue}` : null }
        </Typography>
      </Grid>
      <Grid item xs={meta.length > 0 ? 4 : 1}>
        <Typography align="right" color={meta.length > 0 ? secondaryColor : "inherit"}>
          { meta.length > 0 ? meta : selectIcon(game.sport) }
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Game;
